export const PHONE_RE = /^\+?[0-9 ]{8,16}$/;
export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const passwordScore = (p) => {
  if (!p) return 0;
  let s = 0;
  if (p.length >= 8) s++;
  if (p.length >= 12) s++;
  if (/[a-z]/.test(p) && /[A-Z]/.test(p)) s++;
  if (/\d/.test(p)) s++;
  if (/[^A-Za-z0-9]/.test(p)) s++;
  return Math.min(s, 5);
};

export const passwordOk = (p) => p.length >= 8 && /[A-Za-z]/.test(p) && /\d/.test(p);

export const validIban = (v) => {
  const s = v.replace(/\s/g, "").toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(s) || (s.startsWith("IT") && s.length !== 27)) return false;
  const num = (s.slice(4) + s.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
  let r = 0;
  for (const ch of num) r = (r * 10 + Number(ch)) % 97;
  return r === 1;
};

export const validPiva = (v) => {
  const p = v.replace(/^IT/i, "").replace(/\D/g, "");
  if (!/^\d{11}$/.test(p)) return false;
  let t = 0;
  for (let i = 0; i < 10; i++) {
    let n = Number(p[i]);
    if (i % 2) { n *= 2; if (n > 9) n -= 9; }
    t += n;
  }
  return (10 - (t % 10)) % 10 === Number(p[10]);
};

export const personErrors = (p) => {
  const e = {};
  if (!p.first_name.trim()) e.first_name = "Inserisci il nome";
  if (!p.last_name.trim()) e.last_name = "Inserisci il cognome";
  if (!EMAIL_RE.test(p.email.trim())) e.email = "Email non valida";
  if (!PHONE_RE.test(p.phone.trim())) e.phone = "Telefono non valido";
  return e;
};

export const passwordErrors = (p, c) => {
  const e = {};
  if (!passwordOk(p)) e.password = "Almeno 8 caratteri, con lettere e numeri";
  if (p !== c) e.password_confirm = "Le password non coincidono";
  return e;
};

export const addressErrors = (a) => {
  const e = {};
  if (!a.regione || !a.provincia || !a.comune) e.comune = "Seleziona regione, provincia e comune";
  if (!/^\d{5}$/.test(a.cap)) e.cap = "CAP di 5 cifre";
  if (a.indirizzo.trim().length < 3) e.indirizzo = "Inserisci via e numero civico";
  return e;
};

export const EMPTY_PERSON = { first_name: "", last_name: "", email: "", phone: "" };
export const EMPTY_ADDRESS = { regione: "", provincia: "", comune: "", cap: "", indirizzo: "" };
